import { salesforceDomainPattern } from "@p0security/integrations-salesforce-shared/domain";
import { newSecretManagerElement } from "@p0security/integrations-vaulted-credential-shared";
import {
  Element,
  InstallSpec,
  ItemComponent,
} from "@p0security/shared/install/types";

const allSecretManagers = newSecretManagerElement({
  owner: "Salesforce org",
  connector: "Salesforce",
});

const secretManager = Element({
  ...allSecretManagers,
  default: "gcp-sm",
});

// The id is part of GCP secret ids.
const ITEM_ID_PATTERN = /^[A-Za-z0-9-]+$/;

export const SalesforceAiComponents = InstallSpec({
  org: ItemComponent({
    type: "string",
    label: "Salesforce org",
    description:
      "An org with the P0 Salesforce package, where P0 provisions API-only agent users",
    maturity: "beta",
    validator: async (_context: unknown, id: string) =>
      ITEM_ID_PATTERN.test(id)
        ? undefined
        : "Use only letters, digits and hyphens",
    schema: {
      fullDomain: Element({
        type: "string",
        label: "Full Salesforce domain",
        description:
          "Your full Salesforce domain, including domain suffix (e.g. my-org-domain.foo.my.salesforce.com); defaults to {domain}.my.salesforce.com",
        optional: true,
        step: "new",
        validator: async (_id: string, value: string) =>
          !value || value.match(salesforceDomainPattern)
            ? undefined
            : "Enter only the host, ending with my.salesforce.com (no https:// or /)",
      }),
      secretManager,
      provisionerConsumerKey: Element({
        type: "string",
        label: "Provisioner consumer key",
        description: "Consumer key of the package's P0 Provisioner app",
      }),
      agentClientId: Element({
        type: "string",
        label: "Agent app consumer key",
        description:
          "Consumer key of the package's P0 Agent app, which agents exchange gateway tokens with",
      }),
    },
  }),
});

export type SalesforceAiComponents = typeof SalesforceAiComponents;
